<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>मूल्य मिलान </h2>
                </div>
                <div class="col-md-2 col2"> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>    -->

                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <label for="" class="mt-4">हम आपके ग्राहकों के लिए गेम-चेंजिंग सुविधा पेश करने के लिए उत्साहित हैं: पे जी का प्राइस मैच। अब, खरीदार आपके उत्पादों को प्रतिस्पर्धियों से मिला कर आत्मविश्वास से सर्वोत्तम कीमतों का आनंद ले सकते हैं। यहां बताया गया है कि यह सुविधा आपके और आपके ग्राहकों दोनों के लिए गेम-चेंजर क्यों है: </label>

                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')" id="3">
                    <h2 class="mt-3">पे जी का मूल्य मिलान कैसे काम करता है:  </h2>

                    <label for="" class="mt-4"><b> प्रतिस्पर्धात्मक लाभ: &nbsp;</b> अपने ग्राहकों को विभिन्न दुकानों में कीमतों की तुलना करने के लिए सशक्त बनाएं, यह सुनिश्चित करते हुए कि उन्हें सबसे अच्छा सौदा मिले। </label>
                    <label for="">मूल्य निर्धारण के लिए पारदर्शी और ग्राहक-केंद्रित दृष्टिकोण की पेशकश करके बाज़ार में अलग दिखें।  </label>


                    <label for="" class="mt-4"><b>बेहतर ग्राहक विश्वास:  &nbsp;</b> अपने दर्शकों को विश्वास के साथ खरीदारी करने की अनुमति देकर उनका विश्वास बनाएं, यह जानते हुए कि वे कहीं और बेहतर सौदे नहीं चूकेंगे। </label>


                    <label for="" class="mt-4"><b> निर्बाध एकीकरण:  &nbsp;</b>हमारी मूल्य मिलान सुविधा आपकी चेकआउट प्रक्रिया में सहजता से एकीकृत होती है, जो ग्राहकों के लिए परेशानी मुक्त अनुभव प्रदान करती है। </label>


                    <label for="" class="mt-4"><b>ग्राहक वफादारी: &nbsp;</b> ग्राहकों की वफादारी को यह आश्वासन देकर पुरस्कृत करें कि आप बाजार में सबसे अधिक प्रतिस्पर्धी कीमतों की पेशकश करने के लिए प्रतिबद्ध हैं। </label>


                    <label for="" class="mt-4"><b>नए ग्राहकों को आकर्षित करें: &nbsp;</b> अपने पैसे के लिए सर्वोत्तम मूल्य की तलाश कर रहे नए ग्राहकों को आकर्षित करने के लिए एक शक्तिशाली विपणन उपकरण के रूप में प्राइस मैच का उपयोग करें।  </label>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')" id="4">
                    <h2 class="mt-4">
                        आपके ग्राहकों के लिए लाभ:  
                    </h2>
                    <label class="mt-3" for=""><b>बचत आश्वासन:&nbsp;</b> ग्राहक यह जानकर आत्मविश्वास से खरीदारी कर सकते हैं कि उन्हें आपके उच्च गुणवत्ता वाले उत्पादों के लिए सर्वोत्तम संभव कीमत मिल रही है। 

                    </label>
                    <label class="mt-3" for=""><b> सुव्यवस्थित प्रक्रिया: &nbsp;</b>हमारा उपयोगकर्ता-अनुकूल इंटरफ़ेस ग्राहकों के लिए बिना किसी जटिलता के कीमतों की तुलना और मिलान करना आसान बनाता है। 

                    </label>
                    <label class="mt-3" for=""><b>वास्तविक समय अपडेट: &nbsp;</b> कीमतें वास्तविक समय में गतिशील रूप से समायोजित की जाती हैं, सटीकता सुनिश्चित करती हैं और नवीनतम बाजार स्थितियों को दर्शाती हैं। </label>

                    <label class="mt-3" for=""><b>पारदर्शी खरीदारी अनुभव: &nbsp;</b> पारदर्शिता और निष्पक्षता प्रदर्शित करें, सकारात्मक ग्राहक धारणाओं को बढ़ावा दें और व्यवसाय को दोहराएं। </label>
                    <label for="">पे जी की प्राइस मैच सुविधा के साथ अपने ग्राहकों के खरीदारी अनुभव में क्रांतिकारी बदलाव लाने के लिए तैयार हो जाइए।  </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची: 
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> मूल्य मिलान का परिचय </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> यह काम किस प्रकार करता है?  </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">मूल्य मिलान का उपयोग करने के लाभ  </span>

                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/coupons']"> <button class="btn btn-color"> <img src="./assets/Arrow 3.svg"
                            alt="">&nbsp;&nbsp;कूपन
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/settlement']"> <button class="btn btn-color"> समझौता
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            
            </div>  
        </div>
    </div>
</div>
